import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as myGlobals from './../global';
import { HttpClientSecured } from '../services/http-client-secured';
import { OperationStatus } from '../reportes/operation-status.model';
import { ServiceInstance } from '../reportes/service-instance.model';
import { Observable } from 'rxjs';
import { OperationType } from '../reportes/operation-type-model';
import { ReportFilter } from './report.filter.model';
import { ITransaction } from '../monitor/ITransaction';
import { map } from 'rxjs/operators';
import { ReportTxnModel } from '../reportes/report-txn-model';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  formData: any[] = [];

  fileidUrl = myGlobals.baseApi + '/webadmin/v1/reports/financial';
  operationStatusURL = myGlobals.baseApi + '/webadmin/v1/operationStatuses';
  serviceInstanceURL = myGlobals.baseApi + '/webadmin/v1/service-instances';
  operationTypeURL = myGlobals.baseApi + '/webadmin/v1/operation-types';
  queryTxnURL = myGlobals.baseApi + '/webadmin/v1/reports/financial-raw';

  constructor(private http: HttpClientSecured) {}

  getFileID(reportFilter: ReportFilter) {
    console.log('Get report with filter: ' + JSON.stringify(reportFilter));
    return this.http.post<IFileId>(this.fileidUrl, reportFilter);
  }

  getOperationStatus() {
    return this.http.get<OperationStatus>(this.operationStatusURL);
  }

  getServiceInstance() {
    return this.http.get<ServiceInstance>(this.serviceInstanceURL);
  }

  getOperationTypeCatalog() {
    return this.http.get<OperationType>(this.operationTypeURL);
  }

  getTxnsByFilter(reportFilter: ReportFilter) {
    console.log('Get txns with filter: ' + JSON.stringify(reportFilter));
    return this.http.post<ReportTxnModel[]>(this.queryTxnURL, reportFilter);
  }
}
